import { useUIStore } from '@shared/store/uiStore';
import { theme as antdTheme } from 'antd';

/**
 * Хук для работы с темой приложения
 * Интегрирован с Ant Design и Tailwind CSS
 */
export function useTheme() {
  const currentTheme = useUIStore((state) => state.theme);
  const setTheme = useUIStore((state) => state.setTheme);

  // Получить токены темы Ant Design
  const { token } = antdTheme.useToken();

  return {
    theme: {
      mode: currentTheme,
      token,
    },
    setTheme,
    isDark: currentTheme === 'dark',
    toggleTheme: () => setTheme(currentTheme === 'dark' ? 'light' : 'dark'),
  };
}

/**
 * Хук для получения утилит работы с темой
 */
export function useThemeUtils() {
  const { token } = antdTheme.useToken();

  return {
    /**
     * Получить цвет с прозрачностью
     */
    alpha: (color: string, opacity: number) => {
      return `${color}${Math.round(opacity * 255).toString(16).padStart(2, '0')}`;
    },

    /**
     * Получить градиент
     */
    gradient: (from: string, to: string, direction: string = 'to right') => {
      return `linear-gradient(${direction}, ${from}, ${to})`;
    },

    /**
     * Получить тень
     */
    shadow: (elevation: 'low' | 'medium' | 'high' = 'medium') => {
      const shadows = {
        low: token.boxShadow,
        medium: token.boxShadowSecondary,
        high: '0 12px 28px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.1)',
      };
      return shadows[elevation];
    },

    /**
     * Получить радиус скругления
     */
    radius: (size: 'small' | 'medium' | 'large' = 'medium') => {
      return {
        small: token.borderRadiusSM,
        medium: token.borderRadius,
        large: token.borderRadiusLG,
      }[size];
    },
  };
}


